/**
 * Lazy-initialised Neon SQL tagged-template function.
 *
 * All imports are deferred to runtime (via require) so that
 * `next build` never touches the Neon driver at module scope.
 */
let _sql: any = null;

export function getSql() {
  if (!_sql) {
    const url = process.env.DATABASE_URL;
    if (!url) {
      throw new Error('DATABASE_URL environment variable is not set');
    }
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const { neon } = require('@neondatabase/serverless');
    _sql = neon(url);
  }
  return _sql;
}
